import OrderDetailPage from '@/pages/shared/OrderDetailPage'

/**
 * Sales reads the whole order, including the production timeline, payment,
 * history and the shareable tracking link. It changes nothing about it beyond
 * correcting the job sheet details on orders it took.
 */
export default function SalesOrderDetail() {
  return <OrderDetailPage basePath="/sales" can={{ shipment: false, partner: false, jobSheet: false, lifecycle: false, invoice: true, ai: false }} />
}
